import {getBearerTokenJava, getBearerTokenNode, getStoreLocal} from "../../../_helpers/HNTUtil";

export default function interceptorRequest (config) {
    let token = getBearerTokenNode();
    if (token) {
        config.headers.Authorization = token;
        config.headers.AuthorizationJava = getBearerTokenJava();

        let store = getStoreLocal();
        if (store && store.id > 0) {
            config.headers.storeid = store.id
        }
    }
    return config;
}
